import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

const ProtectedRoute = ({ children }) => {
  const { route, user } = useAuthenticator(context => [context.route, context.user]);

  console.log("ProtectedRoute - Current route:", route); // Debugging line
  console.log("ProtectedRoute - Authenticated user:", user); // Debugging line

  if (route !== 'authenticated') {
    console.log("ProtectedRoute - User is not authenticated, redirecting to login");
    return <Navigate to="/" />;
  }

  console.log("ProtectedRoute - User is authenticated, allowing access");
  return children;
};

export default ProtectedRoute;
